export default {
    SET_COMPANIES_LIST(state, users) {
        state.companyList = users
    },
    SET_ADMIN(state, admin) {
        state.adminCompany = admin
    },
    SET_INFO_DB(state, payload){
        state.infoDB = payload
    },
    UPDATE_COMPANY(state, payload){
        const index = state.companyList.findIndex(company => company.id === payload.id);
        state.companyList.splice(index, 1, payload)
    }
}